import Animal from "../../assets/track_icons/animal_biotechnology 1.webp"
import Biochemistry from "../../assets/track_icons/biochemistry.webp"
import Bioinfomatics from "../../assets/track_icons/bio_infomatics.webp"
import Biomechanics from "../../assets/track_icons/bio_mechanics.webp"
import Environmental from "../../assets/track_icons/environmental_biotechnology.webp"
import Genetic from "../../assets/track_icons/genetic _engineering.webp"
import Graphene from "../../assets/track_icons/graphene.webp"
import Immunology from "../../assets/track_icons/immunology.webp"
import Industrialbiotechnology from "../../assets/track_icons/industrial_biotechnology.webp"
import Microbiology from "../../assets/track_icons/micro_biology.webp"
import Nanoelectronics from "../../assets/track_icons/nano_electronics.webp"
import Nanomaterials from "../../assets/track_icons/nano_materials.webp"
import Nanomedicine from "../../assets/track_icons/nano_medicine.webp"
import Nanotechnology from "../../assets/track_icons/nano_technology.webp"
import Plantbiotechnology from "../../assets/track_icons/plant_biotechnolgy.webp"
import Synthetic from "../../assets/track_icons/synthetic_biology.webp"
import Biophysics from "../../assets/track_icons/bio_physics.webp"
import Nanobiotechnology from "../../assets/track_icons/nano_biotechnology.webp"
import Fermintationtechnology from "../../assets/track_icons/fermentation_technology.webp"
import Molecularbiology from "../../assets/track_icons/molecular_biology.webp"


// data/tracks.js
export const tracks = [
  // 🧬 Biotechnology
  { name: "Animal Biotechnology", icon: Animal },
  { name: "Industrial Biotechnology", icon: Industrialbiotechnology },
  { name: "Plant Biotechnology", icon: Plantbiotechnology },
  { name: "Environmental Biotechnology", icon: Environmental },
  { name: "Genetic Engineering", icon: Genetic },
  { name: "Bioinformatics", icon: Bioinfomatics },

  // 🧪 Nano & Advanced Materials
  { name: "Tissue Engineering", icon: Nanotechnology },
  { name: "Graphene", icon: Graphene },
  { name: "Nanomaterials", icon: Nanomaterials },
  { name: "Nanoelectronics", icon: Nanoelectronics },
  { name: "Nanomedicine", icon: Nanomedicine },
  { name: "NanoBiotechnology", icon: Nanobiotechnology },

  // 🔬 Life Sciences
  { name: "Biochemistry", icon: Biochemistry },
  { name: "Microbiology", icon: Microbiology },
  { name: "Immunology", icon: Immunology },
  { name: "Synthetic Biology", icon: Synthetic },

  // ⚙️ Interdisciplinary Fields
  { name: "Biomechanics", icon: Biomechanics },
  { name: "Biophysics", icon: Biophysics },

  { name: "Molecular Biology", icon: Molecularbiology },
  { name: "Fermentation Technology", icon: Fermintationtechnology },
];